module.exports = __webpack_public_path__ + "img/home_title3.b17eeb6e.png";